import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@storable/canaveral-components';

const propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
};

const defaultProps = {
  className: undefined,
  disabled: undefined,
  href: undefined,
};

const ViewButton = ({
  className,
  disabled,
  href,
}) => {
  const icon = disabled ? 'eye-slash' : 'eye-with-pupil';

  return (
    <Button
      className={className}
      componentClass="a"
      context="bare"
      disabled={disabled}
      href={href}
      icon={icon}
      label="View Live"
      rel="noopener noreferrer"
      size="sm"
      target="_blank"
    />
  );
};

ViewButton.propTypes = propTypes;
ViewButton.defaultProps = defaultProps;

export default ViewButton;
